import React from 'react'
import { View, ActivityIndicator } from 'react-native'
import MobileBackButton from '../../components/simple/MobileBackButton'
import { Status } from '../../components/simple/Status'
import ProfileBanner from '../../components/simple/ProfileBanner'
import Scroller from '../../components/Scroller'

import NavigationActions from '../../utility/navigationActions'
import { graphql, connect, _get } from '../../config/connected'
import schema from './schema'
import i18n from 'i18n-js'
import { isArray } from '../../config/helpers'

import sizes from '../../config/sizes'
import colors from '../../config/colors'
import { stylus } from '../../config/styles'

@graphql(schema.queries.followers, {
  name: 'followersHandler',
  options({ navigation }) {
    return {
      fetchPolicy: 'cache-and-network',
      variables: { id: navigation.state.params.id },
    }
  },
})
@connect(
  ({ screenInfo }) => ({ screenInfo }),
  (dispatch) => ({
    goToProfile: (profile) => {
      NavigationActions.navigate({
        routeName: 'Profile',
        params: { id: profile.id, pageTitle: profile.username },
      })
    },
  }),
)
class FollowersWidgetListViewer extends React.Component {
  getFollowers() {
    const { followersHandler } = this.props
    if (followersHandler.loading) {
      return <ActivityIndicator size='large' style={{ paddingVertical: 60 }} />
    }
    const followers = _get(followersHandler, 'userById.followers', [])

    if (!followers.length) {
      return (
        <Status message={i18n.t('followers.widgetListViewer.emptyMessage')} />
      )
    }
    return followers
  }

  renderFollowers() {
    const followers = this.getFollowers()
    if (!isArray(followers)) {
      return followers // likers is instead a component
    }
    return followers.map((follower) => (
      <ProfileBanner
        key={follower.id}
        profile={follower}
        profileOnPress={this.props.goToProfile}
      />
    ))
  }

  render() {
    return (
      <Scroller style={[styles.followersContainer]}>
        {this.renderFollowers()}
      </Scroller>
    )
  }
}

export default FollowersWidgetListViewer

FollowersWidgetListViewer.navigationOptions = (props) => {
  return {
    headerTitle: i18n.t('followers.widgetListViewer.title'),
    headerLeft: () => (
      <MobileBackButton
        label='Back'
        onPress={() => NavigationActions.back()}
      />
    ),
  }
}

const styles = stylus({
  followersContainer: {
    paddingTop: 10,
  },
})
